import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=7c90d2d2&scoped=true&"
import script from "./SidePanel.vue?vue&type=script&lang=js&"
export * from "./SidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=7c90d2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c90d2d2",
  null
  
)

export default component.exports